import React from "react";
import placeholderImage from "../../../images/event-placeholder-image.jpg";

const formatDate = (dateString) => {
  if (!dateString) return "Not specified";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

const EventView = ({ currentRecord }) => {
  return (
    <div className="w-full max-w-4xl mx-auto overflow-hidden bg-white rounded-lg shadow-lg">
      <div className="relative h-64 bg-gray-200">
        {currentRecord?.image ? (
          <img
            crossOrigin="anonymous"
            src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/event/${currentRecord?.image}`}
            alt="Event"
            className="object-cover w-full h-full"
          />
        ) : (
          <img
            crossOrigin="anonymous"
            src={placeholderImage}
            alt="Event"
            className="object-cover w-full h-full"
          />
        )}
        <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black to-transparent">
          <h1 className="text-3xl font-bold text-white">
            {currentRecord.title}
          </h1>
        </div>
      </div>
      <div className="p-6">
        <p className="mb-4 text-gray-600">{currentRecord.description}</p>
        <div className="grid grid-cols-2 gap-4">
          <EventDetail
            icon="🗓️"
            label="Start Date & Time"
            value={formatDate(currentRecord.view_event_start_date)}
          />
          <EventDetail
            icon="🏁"
            label="End Date & Time"
            value={formatDate(currentRecord.view_event_end_date)}
          />
          <EventDetail
            icon="🏷️"
            label="Event Type"
            value={
              currentRecord.etype ? (
                <span
                  className={`inline-block px-2 py-1 text-xs font-semibold rounded-full ${
                    currentRecord.etype.includes("Public")
                      ? "bg-green-200 text-green-800"
                      : "bg-violet-200 text-violet-800"
                  }`}
                >
                  {currentRecord.etype}
                </span>
              ) : (
                "Not specified"
              )
            }
          />
          <EventDetail
            icon="🕒"
            label="Created At"
            value={formatDate(currentRecord.createdAt)}
          />
        </div>
      </div>
    </div>
  );
};

const EventDetail = ({ icon, label, value }) => (
  <div className="flex items-center">
    <span className="mr-2 text-2xl">{icon}</span>
    <div>
      <p className="text-sm font-medium text-gray-500">{label}</p>
      <div className="text-sm text-gray-900">{value}</div>
    </div>
  </div>
);

export default EventView;
